export default __webpack_public_path__ + "static/media/Fortunato.28e16185.jpeg";